export default __webpack_public_path__ + "static/media/imatge-carrega-video-intro.2994db37.jpg";